type APIError = {
  description: string;
  status: string;
};

const InternalError = {
  description: "Hubo un error interno",
  status: "500",
};

/**
 * If the exception is an object, and it has a description and status property, return the exception,
 * otherwise return the internal error.
 * @param {unknown} ex - unknown
 * @returns An object with two properties: description and status.
 */
export const getException = (ex: unknown): APIError => {
  if (typeof ex !== "object" || !ex) {
    return {
      description: ex as string,
      status: "500",
    };
  }
  const typedException = ex as APIError;

  if (
    ex.hasOwnProperty("description") &&
    typeof typedException.description === "string" &&
    ex.hasOwnProperty("status") &&
    typeof typedException.status === "string"
  ) {
    return {
      description: typedException?.description || "Hubo un error interno",
      status: typedException.status,
    };
  }
  return InternalError;
};
